export const Circle = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 8 9"
      fill={props.fill ? props.fill : "none"}
    >
      <circle
        cx="4"
        cy="4.5"
        r="3.5"
        stroke={props.stroke ? props.stroke : "#404040"}
        strokeOpacity={props.strokeOpacity ? props.strokeOpacity : "0.5"}
      />
    </svg>
  );
};

export const ErrorIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47396 6.82353C7.47396 6.5528 7.70948 6.33333 8 6.33333C8.29052 6.33333 8.52604 6.5528 8.52604 6.82353V8.78431C8.52604 9.05504 8.29052 9.27451 8 9.27451C7.70948 9.27451 7.47396 9.05504 7.47396 8.78431V6.82353Z"
        fill="#FF0000"
      />
      <path
        d="M8 9.86274C7.70948 9.86274 7.47396 10.0822 7.47396 10.3529C7.47396 10.6237 7.70948 10.8431 8 10.8431C8.29052 10.8431 8.52604 10.6237 8.52604 10.3529C8.52604 10.0822 8.29052 9.86274 8 9.86274Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7653 10.5962L13.7682 10.6009C14.4348 11.6837 13.58 13 12.2719 13H3.72807C2.41997 13 1.56522 11.6838 2.23184 10.6009L2.23474 10.5962L6.51054 3.7972C6.66259 3.55357 6.88045 3.35267 7.14088 3.21336C7.40278 3.07327 7.69912 3 8 3C8.30088 3 8.59723 3.07327 8.85912 3.21336C9.11958 3.35268 9.33745 3.55361 9.48949 3.79725L13.7653 10.5962ZM8.39884 4.38982L12.6731 11.1864C12.8483 11.471 12.627 11.8235 12.2719 11.8235H3.72807C3.37303 11.8235 3.15171 11.471 3.32692 11.1864L7.60116 4.38982C7.64132 4.32501 7.69936 4.27114 7.7694 4.23367C7.83945 4.19621 7.919 4.17647 8 4.17647C8.081 4.17647 8.16055 4.19621 8.2306 4.23367C8.30064 4.27114 8.35868 4.32501 8.39884 4.38982Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export const RotateIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "14"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6 1.8337C11.2234 0.646152 9.4897 -0.00254483 7.70033 0.000498944C6.00088 0.000374291 4.34933 0.583725 3.00266 1.66087C1.65613 2.73805 0.690298 4.24766 0.255917 5.95463C-0.178584 7.66172 -0.0573301 9.4702 0.600781 11.098C1.25901 12.726 2.4169 14.0819 3.89434 14.9545C5.37147 15.8272 7.08524 16.1675 8.76823 15.9226C10.4511 15.6776 12.0088 14.8609 13.1984 13.6C13.3328 13.4633 13.4087 13.276 13.4087 13.0806C13.4088 12.8851 13.3331 12.6978 13.1988 12.561C13.0645 12.4241 12.8828 12.3493 12.6947 12.3531C12.5066 12.357 12.328 12.4395 12.199 12.5818C11.6143 13.2058 10.9146 13.7011 10.1417 14.0384C9.36891 14.3758 8.53867 14.5482 7.70047 14.5454C6.35161 14.5454 5.03833 14.0956 3.95393 13.2623C2.86951 12.4291 2.07117 11.2559 1.67638 9.91603C1.28158 8.57619 1.31113 7.13989 1.76075 5.81864C2.21025 4.4975 3.05618 3.36095 4.17387 2.5765C5.29153 1.79206 6.622 1.40112 7.96961 1.46102C9.31715 1.52105 10.6106 2.02875 11.6597 2.90963H10.5001C10.25 2.90963 10.019 3.04817 9.89393 3.27318C9.7689 3.49818 9.7689 3.77553 9.89393 4.00052C10.019 4.22552 10.25 4.36407 10.5001 4.36407H13.3001C13.4857 4.36407 13.6637 4.28749 13.7949 4.15113C13.9263 4.01477 14 3.8297 14 3.63685V0.727844C14 0.468024 13.8665 0.227935 13.65 0.0980248C13.4334 -0.031885 13.1666 -0.031885 12.95 0.0980248C12.7335 0.227935 12.6 0.468028 12.6 0.727844V1.8337Z"
        fill={props.color ? props.color : "white"}
      />
      {!props.removeDot && (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.72042 9.02898L6.71038 10.0575C6.97311 10.3299 7.3291 10.4828 7.70022 10.4828C8.07133 10.4828 8.42733 10.3299 8.69005 10.0575L9.68001 9.02898C9.94216 8.75601 10.0893 8.38613 10.0893 8.00055C10.0893 7.61496 9.94215 7.24508 9.68001 6.97212L8.69005 5.94356C8.42733 5.67122 8.07133 5.51818 7.70022 5.51818C7.3291 5.51818 6.9731 5.6712 6.71038 5.94356L5.72042 6.97212C5.4583 7.24509 5.311 7.61496 5.311 8.00055C5.311 8.38613 5.45829 8.75601 5.72042 9.02898Z"
          fill={props.color ? props.color : "white"}
        />
      )}
    </svg>
  );
};

export const SuccessIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "12"}
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33339 11.3684C5.66067 11.7173 6.1913 11.7173 6.51858 11.3684L15.4074 1.89476C15.7347 1.54595 15.7347 0.980413 15.4074 0.631602C15.0802 0.282792 14.5495 0.282793 14.2223 0.631604L6.5186 8.8421C6.19132 9.19091 5.6607 9.19091 5.33342 8.8421L1.77781 5.05257C1.45053 4.70375 0.919908 4.70376 0.592628 5.05257C0.26535 5.40138 0.265347 5.96691 0.592624 6.31572L5.33339 11.3684Z"
        fill="#00a000"
      />
    </svg>
  );
};

export const CloseIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "72"}
      height={props.height ? props.height : "72"}
      viewBox="0 0 72 72"
      fill="none"
    >
      <path
        d="M14.1394 61.3535L36.002 39.491L57.8685 61.3536L58.222 61.7071L58.5756 61.3535L61.3575 58.5716L61.7111 58.218L61.3575 57.8645L39.4911 36.002L61.3575 14.1395L61.7111 13.7859L61.3575 13.4323L58.5716 10.6464L58.218 10.2929L57.8645 10.6465L36.002 32.5129L14.1395 10.6465L13.7859 10.2929L13.4323 10.6464L10.6464 13.4323L10.2929 13.7859L10.6465 14.1395L32.5129 36.002L10.6465 57.8645L10.2926 58.2183L10.6467 58.5719L13.4326 61.3538L13.7861 61.7069L14.1394 61.3535Z"
        fill={props.color ? props.color : "white"}
        stroke={props.color ? props.color : "white"}
      />
    </svg>
  );
};

export const SearchIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "72"}
      height={props.height ? props.height : "72"}
      viewBox="0 0 72 72"
      fill="none"
    >
      <path
        d="M66 62.8619L49.24 46.1019C53.2675 41.2668 55.2759 35.0651 54.8474 28.7868C54.4188 22.5086 51.5863 16.6374 46.9391 12.3944C42.2919 8.15138 36.1878 5.86337 29.8966 6.00632C23.6054 6.14926 17.6115 8.71216 13.1618 13.1618C8.71216 17.6115 6.14926 23.6054 6.00632 29.8966C5.86337 36.1878 8.15138 42.2919 12.3944 46.9391C16.6374 51.5863 22.5086 54.4188 28.7868 54.8474C35.0651 55.2759 41.2668 53.2675 46.1019 49.24L62.8619 66L66 62.8619ZM10.5179 30.4915C10.5179 26.5411 11.6894 22.6794 13.8841 19.3948C16.0788 16.1101 19.1982 13.5501 22.8479 12.0383C26.4976 10.5266 30.5136 10.131 34.3881 10.9017C38.2626 11.6724 41.8216 13.5747 44.6149 16.368C47.4083 19.1614 49.3106 22.7203 50.0812 26.5948C50.8519 30.4693 50.4564 34.4853 48.9446 38.135C47.4329 41.7847 44.8728 44.9042 41.5882 47.0989C38.3036 49.2936 34.4419 50.465 30.4915 50.465C25.196 50.4591 20.119 48.3529 16.3745 44.6084C12.63 40.8639 10.5238 35.787 10.5179 30.4915Z"
        fill={props.color ? props.color : "white"}
      />
    </svg>
  );
};

export const ValidIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.22275 11.5C6.96616 11.7478 6.55014 11.7478 6.29355 11.5L3.19238 8.5C2.93579 8.25218 2.93579 7.85038 3.19239 7.60256C3.44898 7.35473 3.865 7.35473 4.12159 7.60256L6.29357 9.7051C6.55016 9.95292 6.96618 9.95292 7.22277 9.7051L11.455 5.18587C11.7116 4.93805 12.1277 4.93804 12.3843 5.18587C12.6408 5.43369 12.6408 5.83549 12.3843 6.08331L7.22275 11.5Z"
        fill="#4E4E4E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM14.8 8C14.8 11.7555 11.7555 14.8 8 14.8C4.24446 14.8 1.2 11.7555 1.2 8C1.2 4.24446 4.24446 1.2 8 1.2C11.7555 1.2 14.8 4.24446 14.8 8Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const InfoIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.3 10.1H8.7V11.5H7.3V10.1ZM7.3 4.5H8.7V8.7H7.3V4.5ZM8 1C4.129 1 1 4.15 1 8C1 9.85651 1.7375 11.637 3.05025 12.9497C3.70026 13.5998 4.47194 14.1154 5.32122 14.4672C6.17049 14.8189 7.08075 15 8 15C9.85651 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85651 15 8C15 7.08075 14.8189 6.17049 14.4672 5.32122C14.1154 4.47194 13.5998 3.70026 12.9497 3.05025C12.2997 2.40024 11.5281 1.88463 10.6788 1.53284C9.8295 1.18106 8.91925 1 8 1ZM8 13.6C6.51479 13.6 5.09041 13.01 4.0402 11.9598C2.99 10.9096 2.4 9.48521 2.4 8C2.4 6.51479 2.99 5.09041 4.0402 4.0402C5.09041 2.99 6.51479 2.4 8 2.4C9.48521 2.4 10.9096 2.99 11.9598 4.0402C13.01 5.09041 13.6 6.51479 13.6 8C13.6 9.48521 13.01 10.9096 11.9598 11.9598C10.9096 13.01 9.48521 13.6 8 13.6Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const ProcedureIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.55319 3.79358C4.48298 3.79358 4.42553 3.85138 4.42553 3.92202V4.69266C4.42553 4.7633 4.48298 4.8211 4.55319 4.8211H10.6809C10.7511 4.8211 10.8085 4.7633 10.8085 4.69266V3.92202C10.8085 3.85138 10.7511 3.79358 10.6809 3.79358H4.55319ZM7.48936 6.1055H4.55319C4.48298 6.1055 4.42553 6.1633 4.42553 6.23394V7.00459C4.42553 7.07523 4.48298 7.13303 4.55319 7.13303H7.48936C7.55957 7.13303 7.61702 7.07523 7.61702 7.00459V6.23394C7.61702 6.1633 7.55957 6.1055 7.48936 6.1055ZM6.7234 13.4587H3.14894V2.15596H12.0851V7.29358C12.0851 7.36422 12.1426 7.42202 12.2128 7.42202H13.1064C13.1766 7.42202 13.234 7.36422 13.234 7.29358V1.51376C13.234 1.22959 13.0059 1 12.7234 1H2.51064C2.22819 1 2 1.22959 2 1.51376V14.1009C2 14.3851 2.22819 14.6147 2.51064 14.6147H6.7234C6.79362 14.6147 6.85106 14.5569 6.85106 14.4862V13.5872C6.85106 13.5165 6.79362 13.4587 6.7234 13.4587ZM13.7447 12.0459H11.4468V11.4583C12.1856 11.2367 12.7234 10.5495 12.7234 9.73394C12.7234 8.74014 11.9239 7.93578 10.9362 7.93578C9.9484 7.93578 9.14894 8.74014 9.14894 9.73394C9.14894 10.5479 9.6867 11.2367 10.4255 11.4583V12.0459H8.12766C7.98723 12.0459 7.87234 12.1615 7.87234 12.3028V14.7431C7.87234 14.8844 7.98723 15 8.12766 15H13.7447C13.8851 15 14 14.8844 14 14.7431V12.3028C14 12.1615 13.8851 12.0459 13.7447 12.0459ZM10.1383 9.73394C10.1383 9.29083 10.4957 8.93119 10.9362 8.93119C11.3766 8.93119 11.734 9.29083 11.734 9.73394C11.734 10.1771 11.3766 10.5367 10.9362 10.5367C10.4957 10.5367 10.1383 10.1771 10.1383 9.73394ZM13.0106 14.0046H8.8617V13.0413H13.0106V14.0046Z"
        fill={props.fill}
      />
    </svg>
  );
};

export const ProfileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6663 6.00016C10.6663 6.70741 10.3854 7.38568 9.88529 7.88578C9.3852 8.38588 8.70692 8.66683 7.99967 8.66683C7.29243 8.66683 6.61415 8.38588 6.11406 7.88578C5.61396 7.38568 5.33301 6.70741 5.33301 6.00016C5.33301 5.29292 5.61396 4.61464 6.11406 4.11454C6.61415 3.61445 7.29243 3.3335 7.99967 3.3335C8.70692 3.3335 9.3852 3.61445 9.88529 4.11454C10.3854 4.61464 10.6663 5.29292 10.6663 6.00016ZM9.33301 6.00016C9.33301 6.35378 9.19253 6.69292 8.94248 6.94297C8.69243 7.19302 8.3533 7.3335 7.99967 7.3335C7.64605 7.3335 7.30691 7.19302 7.05687 6.94297C6.80682 6.69292 6.66634 6.35378 6.66634 6.00016C6.66634 5.64654 6.80682 5.3074 7.05687 5.05735C7.30691 4.80731 7.64605 4.66683 7.99967 4.66683C8.3533 4.66683 8.69243 4.80731 8.94248 5.05735C9.19253 5.3074 9.33301 5.64654 9.33301 6.00016Z"
        fill={props.fill ? props.fill : "#404040"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00049 0.999756C4.13458 0.999756 1.00049 4.13385 1.00049 7.99976C1.00049 11.8657 4.13458 14.9998 8.00049 14.9998C11.8664 14.9998 15.0005 11.8657 15.0005 7.99976C15.0005 4.13385 11.8664 0.999756 8.00049 0.999756ZM2.27322 7.99976C2.27322 9.32976 2.72694 10.5541 3.4874 11.5265C4.02145 10.8251 4.71042 10.2568 5.50049 9.86577C6.29056 9.47477 7.16033 9.27172 8.04185 9.27248C8.91197 9.27166 9.7708 9.46945 10.5529 9.8508C11.335 10.2321 12.0197 10.787 12.5549 11.473C13.1063 10.7499 13.4776 9.9058 13.638 9.01068C13.7984 8.11555 13.7433 7.1951 13.4773 6.32547C13.2114 5.45585 12.7422 4.66206 12.1085 4.00978C11.4749 3.3575 10.695 2.86548 9.83346 2.57444C8.97191 2.2834 8.05343 2.2017 7.15404 2.3361C6.25464 2.4705 5.40017 2.81714 4.66134 3.34734C3.92251 3.87753 3.32055 4.57604 2.90527 5.38506C2.48999 6.19409 2.27333 7.09037 2.27322 7.99976ZM8.00049 13.727C6.68573 13.729 5.41066 13.2767 4.39103 12.4467C4.80144 11.8591 5.3477 11.3794 5.98334 11.0484C6.61897 10.7173 7.32517 10.5447 8.04185 10.5452C8.74959 10.5446 9.44725 10.7129 10.0769 11.0361C10.7065 11.3593 11.25 11.828 11.6621 12.4034C10.6346 13.2604 9.3385 13.7289 8.00049 13.727Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const ProfileEditIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.6507 6.54222L1.25978 8.23245C1.2463 8.29424 1.24676 8.35827 1.26114 8.41985C1.27551 8.48144 1.30344 8.53903 1.34287 8.58841C1.38231 8.6378 1.43226 8.67774 1.48908 8.70531C1.5459 8.73288 1.60814 8.74739 1.67127 8.74777C1.70069 8.75074 1.73033 8.75074 1.75974 8.74777L3.45713 8.35613L7.59935 4.21874L5.78191 2.40204L5.78057 2.40071L1.6507 6.54222ZM5.78148 3.43062L2.31299 6.90868L2.07732 7.92769L3.0904 7.69394L6.56954 4.21835L5.78148 3.43062ZM8.62602 3.1943C8.66551 3.15453 8.69679 3.10736 8.71806 3.05547C8.73934 3.00358 8.75019 2.94799 8.75 2.8919C8.74981 2.8358 8.73858 2.78029 8.71695 2.72855C8.69532 2.67681 8.66372 2.62985 8.62396 2.59035L7.41007 1.37421C7.33026 1.29466 7.22226 1.25 7.10969 1.25C6.99711 1.25 6.8891 1.29466 6.8093 1.37421L6.1345 2.05025L7.95118 3.87039L8.62602 3.1943Z"
        fill="#4E4E4E"
      />
    </svg>
  );
};

export const DefaultUserProfileIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "56"}
      height={props.height ? props.height : "56"}
      viewBox="0 0 56 56"
      fill="none"
    >
      <circle cx="28" cy="28" r="28" fill="#F2F2F2" />
      <path
        d="M14 41.6625V35.5127C14 30.5783 18.1787 26.5782 23.3333 26.5782H32.6667C37.8213 26.5782 42 30.5783 42 35.5127V41.6625C38.2444 44.9885 33.3512 47 28 47C22.6488 47 17.7556 44.9885 14 41.6625Z"
        fill="white"
      />
      <path
        d="M36.642 16.5091C36.642 21.091 32.7865 25.3018 28 25.3018C23.2135 25.3018 19.358 21.091 19.358 16.5091C19.358 11.9271 23.2135 8 28 8C32.7865 8 36.642 11.9271 36.642 16.5091Z"
        fill="white"
      />
    </svg>
  );
};

export const DefaultCorporateProfileIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "48"}
      height={props.height ? props.height : "48"}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="#F1F1F1" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3684 10C20.4383 10 19.6842 10.7429 19.6842 11.6593V17.0519H15.6842C14.754 17.0519 14 17.7947 14 18.7111V38H19.6842V17.0519H23.4737C24.4038 17.0519 25.1579 17.7947 25.1579 18.7111V38H34V11.6593C34 10.7429 33.246 10 32.3158 10H21.3684Z"
        fill="#E5E5E5"
      />
    </svg>
  );
};

export const ExitIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.3333 4.66667L10.3933 5.60667L12.1133 7.33333H5.33325V8.66667H12.1133L10.3933 10.3867L11.3333 11.3333L14.6666 8L11.3333 4.66667ZM2.66659 3.33333H7.99992V2H2.66659C1.93325 2 1.33325 2.6 1.33325 3.33333V12.6667C1.33325 13.4 1.93325 14 2.66659 14H7.99992V12.6667H2.66659V3.33333Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const ArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M6.20668 4.47319C6.14488 4.53486 6.09585 4.60812 6.06239 4.68877C6.02894 4.76942 6.01172 4.85587 6.01172 4.94319C6.01172 5.0305 6.02894 5.11695 6.06239 5.1976C6.09585 5.27825 6.14488 5.35151 6.20668 5.41319L8.79335 7.99985L6.20668 10.5865C6.08203 10.7112 6.012 10.8802 6.012 11.0565C6.012 11.2328 6.08203 11.4019 6.20668 11.5265C6.33133 11.6512 6.5004 11.7212 6.67668 11.7212C6.85297 11.7212 7.02203 11.6512 7.14668 11.5265L10.2067 8.46652C10.2685 8.40484 10.3175 8.33158 10.351 8.25093C10.3844 8.17029 10.4016 8.08383 10.4016 7.99652C10.4016 7.90921 10.3844 7.82275 10.351 7.7421C10.3175 7.66145 10.2685 7.58819 10.2067 7.52652L7.14668 4.46652C6.89335 4.21319 6.46668 4.21319 6.20668 4.47319Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const BackArrowIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M3.54368 7.49951H13.9777C14.1161 7.49951 14.2488 7.55218 14.3466 7.64594C14.4445 7.7397 14.4994 7.86686 14.4994 7.99945C14.4994 8.13204 14.4445 8.2592 14.3466 8.35296C14.2488 8.44671 14.1161 8.49939 13.9777 8.49939H3.54368C3.40531 8.49939 3.27261 8.44671 3.17478 8.35296C3.07694 8.2592 3.02197 8.13204 3.02197 7.99945C3.02197 7.86686 3.07694 7.7397 3.17478 7.64594C3.27261 7.55218 3.40531 7.49951 3.54368 7.49951Z"
        fill={props.fill ? props.fill : "#404040"}
      />
      <path
        d="M3.75959 7.99951L8.0866 12.145C8.18456 12.2389 8.23959 12.3662 8.23959 12.4989C8.23959 12.6317 8.18456 12.759 8.0866 12.8529C7.98863 12.9468 7.85577 12.9995 7.71723 12.9995C7.57869 12.9995 7.44583 12.9468 7.34786 12.8529L2.65254 8.35347C2.60395 8.30703 2.56541 8.25186 2.53911 8.19112C2.51281 8.13038 2.49927 8.06527 2.49927 7.99951C2.49927 7.93375 2.51281 7.86864 2.53911 7.8079C2.56541 7.74717 2.60395 7.692 2.65254 7.64556L7.34786 3.14612C7.44583 3.05225 7.57869 2.99951 7.71723 2.99951C7.85577 2.99951 7.98863 3.05225 8.0866 3.14612C8.18456 3.24 8.23959 3.36732 8.23959 3.50008C8.23959 3.63284 8.18456 3.76016 8.0866 3.85404L3.75959 7.99951Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const ClockIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M8 15.5C6.61553 15.5 5.26216 15.0895 4.11101 14.3203C2.95987 13.5511 2.06266 12.4579 1.53285 11.1788C1.00303 9.8997 0.86441 8.49224 1.13451 7.13437C1.4046 5.7765 2.07129 4.52922 3.05026 3.55026C4.02922 2.57129 5.2765 1.9046 6.63437 1.63451C7.99224 1.36441 9.3997 1.50303 10.6788 2.03285C11.9579 2.56266 13.0511 3.45987 13.8203 4.61101C14.5895 5.76216 15 7.11553 15 8.5C15 10.3565 14.2625 12.137 12.9497 13.4497C11.637 14.7625 9.85652 15.5 8 15.5ZM8 2.5C6.81332 2.5 5.65328 2.8519 4.66658 3.51119C3.67989 4.17047 2.91085 5.10755 2.45673 6.2039C2.0026 7.30026 1.88378 8.50666 2.11529 9.67054C2.3468 10.8344 2.91825 11.9035 3.75736 12.7426C4.59648 13.5818 5.66558 14.1532 6.82946 14.3847C7.99335 14.6162 9.19975 14.4974 10.2961 14.0433C11.3925 13.5892 12.3295 12.8201 12.9888 11.8334C13.6481 10.8467 14 9.68669 14 8.5C14 6.9087 13.3679 5.38258 12.2426 4.25736C11.1174 3.13214 9.5913 2.5 8 2.5Z"
        fill={props.fill ? props.fill : "#404040"}
      />
      <path
        d="M10.295 11.5L7.5 8.705V4H8.5V8.29L11 10.795L10.295 11.5Z"
        fill={props.fill ? props.fill : "#404040"}
      />
    </svg>
  );
};

export const AddIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M2.58111 8C2.58102 7.92485 2.59575 7.85043 2.62446 7.78098C2.65318 7.71154 2.69531 7.64844 2.74845 7.5953C2.80158 7.54217 2.86468 7.50004 2.93412 7.47132C3.00357 7.44261 3.07799 7.42788 3.15314 7.42797L7.4296 7.42878L7.42879 3.15232C7.42879 3.0772 7.44359 3.00282 7.47233 2.93342C7.50108 2.86402 7.54322 2.80096 7.59633 2.74784C7.64945 2.69472 7.71251 2.65259 7.78191 2.62384C7.85131 2.59509 7.9257 2.5803 8.00082 2.5803C8.07594 2.5803 8.15032 2.59509 8.21972 2.62384C8.28912 2.65259 8.35218 2.69472 8.4053 2.74784C8.45842 2.80096 8.50055 2.86402 8.5293 2.93342C8.55805 3.00282 8.57284 3.0772 8.57284 3.15232L8.57203 7.42878L12.8485 7.42797C12.9236 7.42797 12.998 7.44277 13.0674 7.47152C13.1368 7.50026 13.1999 7.5424 13.253 7.59552C13.3061 7.64863 13.3482 7.71169 13.377 7.7811C13.4057 7.8505 13.4205 7.92488 13.4205 8C13.4205 8.07512 13.4057 8.1495 13.377 8.2189C13.3482 8.28831 13.3061 8.35137 13.253 8.40448C13.1999 8.4576 13.1368 8.49974 13.0674 8.52848C12.998 8.55723 12.9236 8.57203 12.8485 8.57203L8.57203 8.57122L8.57284 12.8477C8.57284 12.9228 8.55805 12.9972 8.5293 13.0666C8.50055 13.136 8.45842 13.199 8.4053 13.2522C8.35218 13.3053 8.28912 13.3474 8.21972 13.3762C8.15032 13.4049 8.07594 13.4197 8.00082 13.4197C7.9257 13.4197 7.85131 13.4049 7.78191 13.3762C7.71251 13.3474 7.64945 13.3053 7.59633 13.2522C7.54322 13.199 7.50108 13.136 7.47233 13.0666C7.44359 12.9972 7.42879 12.9228 7.42879 12.8477L7.4296 8.57122L3.15314 8.57203C3.07799 8.57212 3.00357 8.55739 2.93412 8.52868C2.86468 8.49996 2.80158 8.45783 2.74845 8.4047C2.69531 8.35156 2.65318 8.28846 2.62446 8.21902C2.59575 8.14957 2.58102 8.07515 2.58111 8Z"
        fill="#404040"
      />
    </svg>
  );
};

export const CallIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.34296 1.68932C4.05288 0.983486 5.22188 1.1089 5.8163 1.9034L6.55246 2.88574C7.03663 3.53207 6.99346 4.43507 6.41888 5.00615L6.28005 5.14499C6.26437 5.20328 6.26277 5.26446 6.27538 5.32349C6.31213 5.56149 6.51105 6.06549 7.34405 6.89382C8.17705 7.72215 8.68455 7.92049 8.92605 7.95782C8.98684 7.97075 9.04984 7.96895 9.1098 7.95257L9.3478 7.71573C9.8588 7.20824 10.6428 7.11315 11.2751 7.45674L12.3893 8.0634C13.3442 8.5814 13.5851 9.87874 12.8035 10.6563L11.9745 11.48C11.7132 11.7396 11.362 11.956 10.9339 11.9962C9.87805 12.0948 7.41813 11.9688 4.83221 9.39807C2.41896 6.99824 1.9558 4.90524 1.89688 3.8739C1.86771 3.3524 2.11388 2.9114 2.42771 2.5999L3.34296 1.68932ZM5.1163 2.42782C4.82055 2.0329 4.26988 2.0014 3.95955 2.30999L3.04371 3.21999C2.85121 3.41132 2.75905 3.62249 2.77071 3.82432C2.81738 4.6439 3.19071 6.53215 5.44938 8.77799C7.81888 11.1335 10.007 11.2041 10.8528 11.1247C11.0255 11.109 11.197 11.0192 11.3574 10.8599L12.1857 10.0357C12.5229 9.70082 12.4488 9.09065 11.9716 8.83165L10.8575 8.22557C10.5495 8.05874 10.189 8.11357 9.96496 8.3364L9.69955 8.60065L9.39038 8.29032C9.69955 8.60065 9.69896 8.60124 9.69838 8.60124L9.6978 8.6024L9.69605 8.60415L9.69196 8.60765L9.68321 8.61582C9.65841 8.63846 9.63189 8.65913 9.60388 8.67765C9.55721 8.70857 9.49538 8.74299 9.4178 8.77157C9.2603 8.83049 9.05146 8.86199 8.79363 8.82232C8.28788 8.74474 7.61763 8.39999 6.72688 7.51449C5.83671 6.62899 5.48905 5.96282 5.41088 5.45765C5.37063 5.19982 5.40271 4.99099 5.46221 4.83349C5.49521 4.74497 5.54207 4.66227 5.60105 4.58849L5.61971 4.56807L5.62788 4.55932L5.63138 4.55582L5.63313 4.55407L5.6343 4.5529L5.8023 4.38607C6.05196 4.13699 6.08696 3.72457 5.85188 3.41015L5.1163 2.42782Z"
        fill="#404040"
      />
    </svg>
  );
};

export const PlayIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <path
        d="M13.155 21.5001C12.9631 21.4997 12.7747 21.4494 12.6081 21.3541C12.2331 21.1416 12 20.7291 12 20.2813V11.2188C12 10.7697 12.2331 10.3585 12.6081 10.146C12.7786 10.048 12.9723 9.99761 13.169 10.0001C13.3656 10.0026 13.558 10.0578 13.7259 10.1601L21.4712 14.7963C21.6327 14.8975 21.7657 15.0381 21.858 15.2048C21.9502 15.3715 21.9986 15.5589 21.9986 15.7494C21.9986 15.94 21.9502 16.1274 21.858 16.2941C21.7657 16.4608 21.6327 16.6013 21.4712 16.7026L13.7247 21.3401C13.5528 21.444 13.3559 21.4993 13.155 21.5001Z"
        fill="#0249D6"
      />
    </svg>
  );
};

export const JamMenuIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "72"}
      height={props.height ? props.height : "72"}
      viewBox="0 0 72 72"
      fill="none"
    >
      <path
        d="M12 16H32C33.0609 16 34.0783 16.4214 34.8284 17.1716C35.5786 17.9217 36 18.9391 36 20C36 21.0609 35.5786 22.0783 34.8284 22.8284C34.0783 23.5786 33.0609 24 32 24H12C10.9391 24 9.92172 23.5786 9.17157 22.8284C8.42143 22.0783 8 21.0609 8 20C8 18.9391 8.42143 17.9217 9.17157 17.1716C9.92172 16.4214 10.9391 16 12 16ZM40 48H60C61.0609 48 62.0783 48.4214 62.8284 49.1716C63.5786 49.9217 64 50.9391 64 52C64 53.0609 63.5786 54.0783 62.8284 54.8284C62.0783 55.5786 61.0609 56 60 56H40C38.9391 56 37.9217 55.5786 37.1716 54.8284C36.4214 54.0783 36 53.0609 36 52C36 50.9391 36.4214 49.9217 37.1716 49.1716C37.9217 48.4214 38.9391 48 40 48ZM12 32H60C61.0609 32 62.0783 32.4214 62.8284 33.1716C63.5786 33.9217 64 34.9391 64 36C64 37.0609 63.5786 38.0783 62.8284 38.8284C62.0783 39.5786 61.0609 40 60 40H12C10.9391 40 9.92172 39.5786 9.17157 38.8284C8.42143 38.0783 8 37.0609 8 36C8 34.9391 8.42143 33.9217 9.17157 33.1716C9.92172 32.4214 10.9391 32 12 32Z"
        fill="white"
      />
    </svg>
  );
};

export const GCCLogo = (props) => {
  return (
    <svg
      width={props.width ? props.width : "72"}
      height={props.height ? props.height : "72"}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="72" height="72" rx="36" fill="white" />
    </svg>
  );
};

export const FilterIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "72"}
      height={props.height ? props.height : "72"}
      viewBox="0 0 72 72"
      fill="none"
    >
      <path
        d="M25.6667 52.2857C25.6667 51.5658 25.952 50.8755 26.4599 50.3664C26.9678 49.8574 27.6567 49.5714 28.375 49.5714H44.625C45.3433 49.5714 46.0322 49.8574 46.5401 50.3664C47.048 50.8755 47.3333 51.5658 47.3333 52.2857C47.3333 53.0056 47.048 53.696 46.5401 54.205C46.0322 54.714 45.3433 55 44.625 55H28.375C27.6567 55 26.9678 54.714 26.4599 54.205C25.952 53.696 25.6667 53.0056 25.6667 52.2857ZM14.8333 36C14.8333 35.2801 15.1187 34.5897 15.6266 34.0807C16.1345 33.5717 16.8234 33.2857 17.5417 33.2857H55.4583C56.1766 33.2857 56.8655 33.5717 57.3734 34.0807C57.8813 34.5897 58.1667 35.2801 58.1667 36C58.1667 36.7199 57.8813 37.4103 57.3734 37.9193C56.8655 38.4283 56.1766 38.7143 55.4583 38.7143H17.5417C16.8234 38.7143 16.1345 38.4283 15.6266 37.9193C15.1187 37.4103 14.8333 36.7199 14.8333 36ZM4 19.7143C4 18.9944 4.28534 18.304 4.79325 17.795C5.30116 17.286 5.99004 17 6.70833 17H66.2917C67.01 17 67.6988 17.286 68.2067 17.795C68.7147 18.304 69 18.9944 69 19.7143C69 20.4342 68.7147 21.1245 68.2067 21.6336C67.6988 22.1426 67.01 22.4286 66.2917 22.4286H6.70833C5.99004 22.4286 5.30116 22.1426 4.79325 21.6336C4.28534 21.1245 4 20.4342 4 19.7143Z"
        fill="white"
      />
    </svg>
  );
};

export const PauseIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <path
        d="M12 12.6429C12 12.2878 12.2878 12 12.6429 12V12C12.9979 12 13.2857 12.2878 13.2857 12.6429V20.3571C13.2857 20.7122 12.9979 21 12.6429 21V21C12.2878 21 12 20.7122 12 20.3571V12.6429ZM18.4286 12.6429C18.4286 12.2878 18.7164 12 19.0714 12V12C19.4265 12 19.7143 12.2878 19.7143 12.6429V20.3571C19.7143 20.7122 19.4265 21 19.0714 21V21C18.7164 21 18.4286 20.7122 18.4286 20.3571V12.6429Z"
        fill="#0249D6"
      />
    </svg>
  );
};

export const MicIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <path
        d="M18.5 15.4615C18.5 16.1756 18.2366 16.8604 17.7678 17.3653C17.2989 17.8702 16.663 18.1538 16 18.1538C15.337 18.1538 14.7011 17.8702 14.2322 17.3653C13.7634 16.8604 13.5 16.1756 13.5 15.4615V11.6923C13.5 10.9783 13.7634 10.2935 14.2322 9.78856C14.7011 9.28365 15.337 9 16 9C16.663 9 17.2989 9.28365 17.7678 9.78856C18.2366 10.2935 18.5 10.9783 18.5 11.6923V15.4615Z"
        stroke="#0249D6"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 16C21.0013 16.6368 20.8858 17.2676 20.6601 17.8562C20.4345 18.4448 20.103 18.9796 19.6849 19.4299C19.2668 19.8802 18.7702 20.2371 18.2236 20.4802C17.6771 20.7232 17.0913 20.8476 16.5 20.8462H15.5C14.9087 20.8476 14.3229 20.7232 13.7764 20.4802C13.2298 20.2371 12.7332 19.8802 12.3151 19.4299C11.897 18.9796 11.5655 18.4448 11.3399 17.8562C11.1142 17.2676 10.9987 16.6368 11 16M16 20.8462V23"
        stroke="#0249D6"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const StopIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.6" cx="16" cy="16" r="15.5" stroke="#0249D6" />
      <rect x="10" y="10" width="12" height="12" rx="2" fill="#0249D6" />
    </svg>
  );
};

export const CalendarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6875 14H1.3125C0.58625 14 0 13.4137 0 12.6875V2.1875C0 1.46125 0.58625 0.875 1.3125 0.875H12.6875C13.4137 0.875 14 1.46125 14 2.1875V12.6875C14 13.4137 13.4137 14 12.6875 14ZM1.3125 1.75C1.0675 1.75 0.875 1.9425 0.875 2.1875V12.6875C0.875 12.9325 1.0675 13.125 1.3125 13.125H12.6875C12.9325 13.125 13.125 12.9325 13.125 12.6875V2.1875C13.125 1.9425 12.9325 1.75 12.6875 1.75H1.3125Z"
        fill="#404040"
      />
      <path
        d="M3.9375 3.5C3.6925 3.5 3.5 3.3075 3.5 3.0625V0.4375C3.5 0.1925 3.6925 0 3.9375 0C4.1825 0 4.375 0.1925 4.375 0.4375V3.0625C4.375 3.3075 4.1825 3.5 3.9375 3.5ZM10.0625 3.5C9.8175 3.5 9.625 3.3075 9.625 3.0625V0.4375C9.625 0.1925 9.8175 0 10.0625 0C10.3075 0 10.5 0.1925 10.5 0.4375V3.0625C10.5 3.3075 10.3075 3.5 10.0625 3.5ZM13.5625 5.25H0.4375C0.1925 5.25 0 5.0575 0 4.8125C0 4.5675 0.1925 4.375 0.4375 4.375H13.5625C13.8075 4.375 14 4.5675 14 4.8125C14 5.0575 13.8075 5.25 13.5625 5.25Z"
        fill="#404040"
      />
    </svg>
  );
};

export const ProcedureTitleIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.354 5.104C7.44789 5.01011 7.50063 4.88278 7.50063 4.75C7.50063 4.61722 7.44789 4.48989 7.354 4.396C7.26011 4.30211 7.13278 4.24937 7 4.24937C6.86722 4.24937 6.73989 4.30211 6.646 4.396L5.234 5.808L4.837 5.446C4.73836 5.36169 4.6108 5.31903 4.48129 5.32703C4.35177 5.33504 4.23044 5.39308 4.14293 5.4889C4.05543 5.58472 4.0086 5.7108 4.01234 5.84051C4.01609 5.97022 4.07011 6.09339 4.163 6.184L4.913 6.869C5.00803 6.95552 5.13272 7.00213 5.2612 6.99915C5.38968 6.99617 5.51208 6.94383 5.603 6.853L7.353 5.103L7.354 5.104ZM7.354 9.396C7.40056 9.44245 7.43751 9.49762 7.46271 9.55837C7.48792 9.61911 7.50089 9.68423 7.50089 9.75C7.50089 9.81577 7.48792 9.88089 7.46271 9.94163C7.43751 10.0024 7.40056 10.0576 7.354 10.104L5.604 11.854C5.51291 11.945 5.39023 11.9973 5.26151 12.0001C5.13279 12.0029 5.00796 11.9559 4.913 11.869L4.163 11.184C4.07011 11.0934 4.01609 10.9702 4.01234 10.8405C4.0086 10.7108 4.05543 10.5847 4.14293 10.4889C4.23044 10.3931 4.35177 10.335 4.48129 10.327C4.6108 10.319 4.73836 10.3617 4.837 10.446L5.234 10.809L6.646 9.396C6.69245 9.34944 6.74762 9.31249 6.80837 9.28729C6.86911 9.26208 6.93423 9.24911 7 9.24911C7.06577 9.24911 7.13089 9.26208 7.19163 9.28729C7.25238 9.31249 7.30755 9.34944 7.354 9.396ZM9 10C8.86739 10 8.74021 10.0527 8.64645 10.1464C8.55268 10.2402 8.5 10.3674 8.5 10.5C8.5 10.6326 8.55268 10.7598 8.64645 10.8536C8.74021 10.9473 8.86739 11 9 11H11.5C11.6326 11 11.7598 10.9473 11.8536 10.8536C11.9473 10.7598 12 10.6326 12 10.5C12 10.3674 11.9473 10.2402 11.8536 10.1464C11.7598 10.0527 11.6326 10 11.5 10H9ZM8.5 5.5C8.5 5.36739 8.55268 5.24021 8.64645 5.14645C8.74021 5.05268 8.86739 5 9 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5C12 5.63261 11.9473 5.75979 11.8536 5.85355C11.7598 5.94732 11.6326 6 11.5 6H9C8.86739 6 8.74021 5.94732 8.64645 5.85355C8.55268 5.75979 8.5 5.63261 8.5 5.5ZM4 1C3.20435 1 2.44129 1.31607 1.87868 1.87868C1.31607 2.44129 1 3.20435 1 4V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H12C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12V4C15 3.20435 14.6839 2.44129 14.1213 1.87868C13.5587 1.31607 12.7956 1 12 1H4ZM2 4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H12C12.5304 2 13.0391 2.21071 13.4142 2.58579C13.7893 2.96086 14 3.46957 14 4V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V4Z"
        fill="#404040"
      />
    </svg>
  );
};

export const LocationIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "72"}
      height={props.height ? props.height : "72"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9999 14.1253L8.48066 13.5835C9.02618 12.9588 9.51685 12.366 9.95342 11.8022L10.3138 11.3268C11.8186 9.29934 12.5713 7.6902 12.5713 6.50087C12.5713 3.9622 10.5248 1.9043 7.9999 1.9043C5.47494 1.9043 3.42847 3.9622 3.42847 6.50087C3.42847 7.6902 4.18123 9.29934 5.68599 11.3268L6.04637 11.8022C6.66918 12.6002 7.32079 13.3746 7.9999 14.1253Z"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99998 8.38081C9.05195 8.38081 9.90474 7.52802 9.90474 6.47605C9.90474 5.42408 9.05195 4.57129 7.99998 4.57129C6.94801 4.57129 6.09521 5.42408 6.09521 6.47605C6.09521 7.52802 6.94801 8.38081 7.99998 8.38081Z"
        stroke="#404040"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "20"}
      height={props.height ? props.height : "20"}
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M6.875 22.375L15.625 31.125L33.125 12.375"
        stroke={props.color ? props.color : "#404040"}
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const TickIconWithCircle = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M11.5145 5.31536C11.6887 5.48961 11.6887 5.77213 11.5145 5.94638L6.8144 10.6464C6.61914 10.8417 6.30256 10.8417 6.1073 10.6464L4.31563 8.85478C4.14131 8.68046 4.14131 8.39784 4.31563 8.22352C4.4898 8.04935 4.77212 8.04918 4.9465 8.22313L6.10746 9.38126C6.30273 9.57605 6.61885 9.57593 6.81397 9.38099L10.8836 5.31521C11.0579 5.1411 11.3403 5.14117 11.5145 5.31536Z"
        fill="#2965DD"
      />
      <circle cx="8" cy="8" r="6.5" stroke="#2965DD" />
    </svg>
  );
};

export const EditIcon = (props) => {
  return (
    <svg
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "17"}
      viewBox="0 0 16 17"
      fill="none"
    >
      <g id="Edit">
        <path
          id="Vector"
          d="M9.76471 4.1114L11.8824 6.33753M8.35294 14.5H14M2.70588 11.5318L2 14.5L4.82353 13.758L13.0019 5.16065C13.2665 4.88234 13.4152 4.50493 13.4152 4.1114C13.4152 3.71787 13.2665 3.34046 13.0019 3.06215L12.8805 2.93452C12.6157 2.6563 12.2567 2.5 11.8824 2.5C11.508 2.5 11.149 2.6563 10.8842 2.93452L2.70588 11.5318Z"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const LanguageIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ? props.width : "16"}
      height={props.height ? props.height : "16"}
      viewBox="0 0 16 16"
      fill="none"
    >
      <g clipPath="url(#clip0_2801_2885)">
        <path
          d="M0 9L3.45753 1H4.56632L8 9H6.99851L5.94933 6.48571H2.0149L0.9538 9H0ZM2.33681 5.73143H5.62742L3.98212 1.81143L2.33681 5.73143Z"
          fill="white"
        />
        <path
          d="M8.70968 15.1146C8.04731 15.1146 7.49419 15.0321 7.05033 14.8671C6.60647 14.709 6.27187 14.4856 6.04652 14.1969C5.82801 13.9151 5.71875 13.5885 5.71875 13.2174C5.71875 13.0455 5.75631 12.8771 5.83142 12.7121C5.90654 12.5471 6.02262 12.4097 6.17968 12.2997C6.26845 12.2378 6.36405 12.1863 6.46648 12.145C6.56891 12.1038 6.70207 12.0728 6.86596 12.0522C7.03667 12.0316 7.2586 12.0213 7.53175 12.0213H15.1832L15.2139 12.7637H7.64442C7.43273 12.7637 7.26885 12.7671 7.15276 12.774C7.0435 12.7809 6.96156 12.7946 6.90693 12.8152C6.8523 12.8358 6.79767 12.8668 6.74304 12.908C6.64061 12.9905 6.5894 13.1074 6.5894 13.2586C6.5894 13.5954 6.77036 13.8635 7.13227 14.0629C7.49419 14.2622 8.04048 14.3619 8.77114 14.3619H8.94527C9.63496 14.3619 10.2256 14.2794 10.7173 14.1144C11.2158 13.9563 11.6255 13.7363 11.9464 13.4545C12.2742 13.1727 12.52 12.853 12.6839 12.4956L12.7249 12.2997C12.7864 12.1278 12.8308 11.956 12.8581 11.7841C12.8854 11.6054 12.899 11.4267 12.899 11.248C12.899 10.8493 12.8308 10.4712 12.6942 10.1137C12.5576 9.7563 12.3459 9.45728 12.0591 9.2167C11.7791 8.96923 11.4172 8.81113 10.9734 8.74239C10.8846 8.72864 10.7992 8.72177 10.7173 8.72177C10.6422 8.71489 10.5602 8.71146 10.4715 8.71146C10.2598 8.71146 10.0652 8.74926 9.88762 8.82488C9.71008 8.90049 9.56667 9.01391 9.45742 9.16514C9.35499 9.31637 9.30377 9.50884 9.30377 9.74255C9.30377 9.99689 9.37889 10.2134 9.52912 10.3921C9.68617 10.564 9.90469 10.6499 10.1847 10.6499C10.4442 10.6499 10.649 10.5709 10.7992 10.4128C10.9563 10.2478 11.0348 10.0141 11.0348 9.71162C11.0348 9.48478 10.9973 9.282 10.9222 9.10327C10.8539 8.91768 10.731 8.74239 10.5534 8.57741L11.1373 8.40213C11.2602 8.50524 11.3728 8.62553 11.4753 8.76301C11.5845 8.90049 11.6699 9.05516 11.7313 9.22701C11.7996 9.39198 11.8338 9.56727 11.8338 9.75287C11.8338 9.99345 11.7962 10.2134 11.7211 10.4128C11.6528 10.6052 11.547 10.7737 11.4036 10.918C11.2602 11.0555 11.0826 11.162 10.8709 11.2376C10.6661 11.3133 10.4305 11.3511 10.1642 11.3511C9.85689 11.3511 9.57692 11.2926 9.32426 11.1758C9.0716 11.0589 8.87016 10.8836 8.71993 10.6499C8.5697 10.4162 8.49458 10.1275 8.49458 9.7838C8.49458 9.35761 8.5936 9.01391 8.79163 8.7527C8.98966 8.49149 9.24573 8.30246 9.55985 8.1856C9.88079 8.06187 10.2188 8 10.5739 8C11.0997 8 11.5606 8.08936 11.9567 8.26809C12.3596 8.44681 12.6942 8.69084 12.9605 9.00016C13.2336 9.30949 13.4385 9.65663 13.5751 10.0416C13.7116 10.4265 13.7799 10.8252 13.7799 11.2376C13.7799 11.4232 13.7697 11.6054 13.7492 11.7841C13.7287 11.956 13.698 12.1244 13.657 12.2894L13.5956 12.5162C13.4044 13.0799 13.0834 13.5542 12.6327 13.9391C12.1889 14.3241 11.6494 14.6162 11.0143 14.8156C10.3861 15.0149 9.68959 15.1146 8.92478 15.1146H8.70968ZM15.1218 15.4239V8.12373H16.0026V15.4239H15.1218Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2801_2885">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ErrorBoundaryFallBack = () => {
  return (
    <svg
      width="147"
      height="156"
      viewBox="0 0 147 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.56294 132.768C3.97014 130.648 5.47455 128.904 7.5123 128.191L21.646 123.243C25.0618 122.048 28.7572 124.093 29.5583 127.622L34.0771 147.529C35.0102 151.639 31.5658 155.424 27.3857 154.88L6.3846 152.15C2.92267 151.7 0.555873 148.425 1.21431 144.997L3.56294 132.768Z"
        fill="#F1F1F1"
      />
      <path
        d="M128.913 12.6104C128.491 8.16241 132.863 4.80178 137.052 6.35423L139.977 7.43804C141.626 8.04898 142.928 9.3459 143.546 10.9922L144.406 13.2843C145.748 16.8631 143.483 20.7759 139.711 21.3936L136.3 21.9522C132.838 22.5191 129.619 20.0372 129.287 16.5449L128.913 12.6104Z"
        fill="#F1F1F1"
      />
      <path
        d="M128.581 117.383C128.313 114.445 131.226 112.249 133.977 113.314C135.052 113.731 135.894 114.594 136.284 115.679L136.383 115.955C137.226 118.305 135.743 120.846 133.282 121.267C130.974 121.662 128.819 120.006 128.607 117.674L128.581 117.383Z"
        fill="#F1F1F1"
      />
      <path
        d="M18.8427 13.6181C18.4421 10.4723 21.3737 7.9331 24.4301 8.77845L27.072 9.50915C28.133 9.80259 29.0203 10.5311 29.5146 11.5147C30.7252 13.9236 29.1822 16.8044 26.5061 17.1315L23.7853 17.4641C21.3602 17.7605 19.1513 16.0417 18.8427 13.6181Z"
        fill="#F1F1F1"
      />
      <path
        d="M37.8677 31.6791C37.0845 27.6202 40.6294 24.0445 44.6949 24.7926L107.114 36.279C110.262 36.8582 112.365 39.8514 111.844 43.0089L106.384 76.0969C106.304 76.5809 106.282 77.0726 106.317 77.5619L108.123 102.726C108.362 106.054 105.781 108.913 102.446 109.014L49.7149 110.62C46.4039 110.721 43.6651 108.065 43.6651 104.752V62.3188C43.6651 61.9214 43.6272 61.5248 43.5519 61.1346L37.8677 31.6791Z"
        fill="#F1F1F1"
        stroke="#959595"
        strokeWidth="0.378774"
      />
      <circle cx="62" cy="65" r="8" fill="#E5E5E5" />
      <circle cx="67.5" cy="70.5" r="2.5" fill="#959595" />
      <circle cx="87" cy="65" r="8" fill="#E5E5E5" />
      <circle cx="81.5" cy="70.5" r="2.5" fill="#959595" />
      <path
        d="M58 95C62.9998 91.2645 76.81 80.8642 91 89.0827"
        stroke="#959595"
        strokeWidth="0.757547"
      />
      <path
        d="M68 35.3333L71.6 29L74 29.6667L69.5 35.3333L73.4 41L70.4 50L72.8 41L68 35.3333Z"
        fill="#959595"
      />
    </svg>
  );
};
